import React from 'react'
import { components } from 'react-select'
import styled from 'styled-components'
import { rem } from 'polished'
import cn from 'clsx'
import { mediaQueryUp } from 'components/utils/breakpoint'
import zIndex from 'styles/tools/z-index'

import LineSearchIcon from 'components/Luxkit/Icons/line/LineSearchIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import IconButton from 'components/Luxkit/Button/IconButton'
import SolidTimesCircleIcon from 'components/Luxkit/Icons/solid/SolidTimesCircleIcon'

const IconWrapper = styled.div`
  z-index: ${zIndex.min};
  position: absolute;
  height: 100%;
  display: flex;
  align-items: center;
  margin-left: ${rem(24)};

  ${mediaQueryUp.sm} {
    display: none;
  }
`

const StyledBodyText = styled(BodyText).attrs({
  className: 'react-select-label', /* pass class name react-select-label to component */
})`
  position: static;
  height: ${rem(20)};
  display: none;
  padding-left: ${rem(16)};
  padding-top: ${rem(4)};

  ${mediaQueryUp.sm} {
    display: block;
  }
`

const ChildrenContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  max-width: 100%;
  position: relative;
  z-index: ${zIndex.balloon};

  ${mediaQueryUp.sm}{
    min-height: ${rem(35)};
  }
`

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`

type Props = React.ComponentProps<typeof components.ValueContainer>

function ValueContainer({ children, ...props }: Props) {
  const {
    hasValue,
    selectProps: { inputValue, isClearable, titleLabel, clearValue },
  } = props

  const isClearButtonVisible = isClearable && Boolean(inputValue)

  return (
    <components.ValueContainer {...props}>
      <Wrapper>
        <IconWrapper>
          <LineSearchIcon size={24} colour="primary" />
        </IconWrapper>
        <ChildrenContainer className={cn({ 'is-active': hasValue })}>
          <StyledBodyText variant="medium" weight="bold" colour="neutral-one">
            {titleLabel}
          </StyledBodyText>
          {children}
        </ChildrenContainer>
        { isClearButtonVisible &&
          <IconButton kind="tertiary" size="large" onClick={clearValue}>
            <SolidTimesCircleIcon />
          </IconButton>
        }
      </Wrapper>
    </components.ValueContainer>
  )
}

export default ValueContainer
